import { render, staticRenderFns } from "./JgpAdvTable.vue?vue&type=template&id=111e2433&"
import script from "./JgpAdvTable.vue?vue&type=script&lang=js&"
export * from "./JgpAdvTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports